<template>
    <div
        ref="personCardWrapper"
        class="participant-card-wrapper"
        :class="{'active': editMode}">
        <div class="participant-card">
            <!-- IMPORTANT keep alive allows vee validate to check nested validation observers-->
            <KeepAlive v-if="rendered">
                <slot />
            </KeepAlive>
            <div
                v-else
                class="d-flex justify-content-center align-items-center h-100">
                <DefaultSpinner
                    class="text-muted"
                    size="xl" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PersonCardWrapper",
    props: {
        editMode: {
            type: Boolean,
            default: false
        },
        delayRender: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            rendered: false
        }
    },
    mounted() {
        if (!this.delayRender) {
            this.rendered = true;
            return;
        }
        const randomTimeOut = Math.floor(Math.random() * 100) + 50
        setTimeout(() => {
            this.rendered = true;
        }, randomTimeOut);
    },
    watch: {
        editMode: {
            handler(isEditMode) {
                if (isEditMode) {
                    this.$nextTick(() => {
                        if (this.$refs.personCardWrapper) {
                            this.$refs.personCardWrapper.scrollIntoView({behavior: "smooth"});
                        }
                    })
                }
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
@use "sass:map";

.participant-card-wrapper.active {
    grid-column: 1/ -1;
}

.participant-card {
    box-shadow: 0 0 2rem 0 color-mix(in srgb, var(--custom-secondary-color, $gray-600) 15%, transparent);
    background: var(--custom-surface-color, $white);
    border-radius: var(--custom-border-radius, 0.25rem);
    padding: map.get($spacers, 3);
    height: 100%;
}

</style>